import api from '../../../util/api'

const permissions = '/interface/v1/user-perminfo/'
const groups = '/interface/v1/custom-group/'
const permList = '/interface/v1/custom-permission/'
const userList = '/interface/v1/user-listinfo/'
const imachUserList = '/interface/v1/user-listinfo/?company_filter='
const excelSales = '/interface/v1/sale-export/'
const excelMovements = '/interface/v1/movement-export/'
const excelBalance = '/interface/v1/balance-export/'
const company = '/interface/v1/company/'
const feature = '/interface/v1/feature-flags/' 
// const status = '/interface/v1/company/' OLD
const status = '/interface/v1/vm-status/'

export default {
  async getPermission({ commit }) {
    try {
      const res = await api.get(permissions);
      const data = await res.json();
      commit("setPermission", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async dismiss({ commit }, { id, item }) {
    try {
      const res = await api.patch(permissions + id + '/', item);
      const data = await res.json();
      dispatch("getPermission");
      return data;
    } catch (err) {
      return err;
    }
  },
  async list({ commit }) {
    try {
      const res = await api.get(groups);
      const data = await res.json();
      commit("set", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async options({ commit }) {
    try {
      const res = await api.options(feature);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async flag({ commit },{ id }) {
    try {
      const res = await api.get(feature + '?page_size=100&company=' + id);
      const data = await res.json();
      commit("setFlag", { data: data.results });
      return data;
    } catch (err) {
      return err;
    }
  },
  // async statusVM({ commit },{ id }) {
  //   try {
  //     const res = await api.get(status + id + '/machine_status/');
  //     const data = await res.json();
  //     return data;
  //   } catch (err) {
  //     return err;
  //   }
  // },
  async statusVM({ commit },{ search }) {
    try {
      const res = await api.get(status + search);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async flagGet({ commit },{ id }) {
    try {
      const res = await api.get(feature +  id);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async flagCreate({ commit }, { item }) {
    try {
      const res = await api.post(feature, item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async flagUpdate({ commit }, { item }) {
    try {
      const res = await api.put(feature + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async flagDelete({ dispatch }, { id }) {
    try {
      const res = await api.delete(feature + id + '/');
      return res;
    } catch (err) {
      return err;
    }
  },
  async groupCompany({ commit }, {search: company}) {
    try {
      const res = await api.get(groups + company);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async excelSell({ commit }, {search: filter}) {
    try {
      const res = await api.getForm(excelSales + filter);
      const blob = await res.blob()
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "Vendas.xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();    
      a.remove();
      return false
    } catch (err) {
      return err;
    }
  },
  async excelMovement({ commit }, {search: filter}) {
    try {
      const res = await api.getForm(excelMovements + filter);
      const blob = await res.blob()
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "Movimentos.xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();    
      a.remove(); 
      return false
    } catch (err) {
      return err;
    }
  },
  async excelBalance({ commit }, {search: filter}) {
    try {
      const res = await api.getForm(excelBalance + filter);
      const blob = await res.blob()
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = "Receita.xlsx";
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();    
      a.remove();
      return false
    } catch (err) {
      return err;
    }
  },
  async get({ commit }, { id }) {
    try {
      const res = await api.get(groups + id);
      const data = await res.json();
      commit("show", { data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      const res = await api.delete(groups + id + '/');
      return res;
    } catch (err) {
      return err;
    }
  },
  async listPerm({ commit }) {
    try {
      const res = await api.get(permList);
      const data = await res.json();
      commit("setPerm", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async listUser({ commit }) {
    try {
      const res = await api.get(userList);
      const data = await res.json();
      commit("setUser", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async update({ commit }, { item }) {
    try {
      const res = await api.put(groups + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async create({ commit }, { item }) {
    try {
      const res = await api.post(groups, item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async imachListUser({ commit }, { id }) {
    try {
      const res = await api.get(imachUserList + id);
      const data = await res.json();
      commit("setUser", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async companyExpire({ commit }, { id }) {
    try {
      const res = await api.get(company + id + '/coils_to_expire/?days_limit=20');
      const data = await res.json();
      commit("setCompExpire", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
  async companySoldOut({ commit }, { id }) {
    try {
      const res = await api.get(company + id + '/coils_to_sold_out/?percent=30');
      const data = await res.json();
      commit("setCompSoldOut", { data: data });
      return data;
    } catch (err) {
      return err;
    }
  },
}
